export default "/assets/images/slide-mini-sm.16999ac4f8d7cf7c.webp";